'use client';

import { Button, Card, CardContent, CardDescription, CardHeader, CardTitle, cn } from '@repo/ui';
import { Home } from 'lucide-react';
import Link from 'next/link';
import type React from 'react';
import { LazyLottie } from '../../components/lazy-lottie';

export function ComingSoonDashboardTemplate({
  className,
  homeHref = '/',
  title = 'Dashboard Coming Soon',
  description = 'We are building an amazing dashboard experience for you. Stay tuned!',
  ...props
}: React.ComponentProps<'div'> & {
  homeHref?: string;
  title?: string;
  description?: string;
}): React.ReactNode {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-6 select-none pt-[10vh]',
        className,
      )}
      {...props}
    >
      <div className="flex items-center justify-center">
        <LazyLottie
          src="/lottie/heart-hi.lottie.json"
          className="h-96 rounded-xl overflow-hidden"
        />
      </div>
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl">{title}</CardTitle>
          <CardDescription className="text-base">{description}</CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col items-center gap-4">
          <Button asChild>
            <Link href={homeHref}>
              <Home />
              Go Home
            </Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
